import { Invite } from "../../models";

export interface InviteListResult {
  invites: Invite[];
  inviteCount: { total: number; currentPage: number };
  pages: { total: number; currentPage: number };
}
